import { SelectionModel } from "@angular/cdk/collections";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ListColumn } from "src/@fury/shared/list/list-column.model";
import { Confirmation } from "src/app/enums/confirmation.enum";
import { ErrorText } from "src/app/enums/error-text.enum";
import { ErrorType } from "src/app/enums/error-type.enum";
import { PartnersRoute } from "src/app/enums/partners-route.enum";
import { ApiService } from "src/app/services/api.service";
import { PartnerActionComponent } from "src/app/shared/partner-action/partner-action.component";
import { ReviewComponent } from "src/app/shared/review/review.component";
import { VendorFormComponent } from "src/app/shared/vendor-form/vendor-form.component";
import { FormControl, FormGroup } from "@angular/forms";
import { FilterFormModal, FilterValue } from "src/app/models/form-group.model";
import { CommonService } from "src/app/services/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AddCompanyComponent } from "../../component/add-company/add-company.component";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";

@Component({
  selector: "fury-general-service-provider",
  templateUrl: "./general-service-provider.component.html",
  styleUrls: ["./general-service-provider.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class GeneralServiceProviderComponent implements OnInit {
  isShowCompany = false;
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  services: any[] = [];
  companies: any[] = [];
  kpiData = null;
  tabName = "pending";
  ngUnsubscribe = new Subject<void>();
  tabNames = {
    Pending: "pending",
    Approved: "approved",
    Declined: "declined",
  };
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  searchForm = new FormGroup({
    companyName: new FormControl(""),
    companyAddress: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    companyEmail: new FormControl(""),
    workOrderEmailAddress: new FormControl(""),
    workOrderPhoneNumber: new FormControl(""),
    companyLicense: new FormControl(""),
    companyPhone: new FormControl(""),
    agreementNumber: new FormControl(""),
  });
  isLoading = false;
  searchValue: any = {};
  constructor(public dialog: MatDialog, private apiService: ApiService) {}

  ngOnInit(): void {
    this.getServices();
    this.getAllCompanies();
  }

  getServices() {
    this.apiService
      .get(endpoints.partners.serviceProvider.getServices)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.services = res.body?.services;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  getAllCompanies() {
    this.isLoading = true;
    this.apiService
      .get(
        endpoints.partners.serviceProvider.getAllCompanies +
          `?page=${this.pageIndex + 1}&size=${this.pageSize}&status=${
            this.tabName
          }&companyName=${this.searchValue?.companyName || ""}&companyAddress=${
            this.searchValue?.companyAddress || ""
          }&state=${this.searchValue?.state || ""}&zip=${
            this.searchValue?.zip || ""
          }&companyEmail=${this.searchValue?.companyEmail || ""}&companyPhone=${
            this.searchValue?.companyPhone || ""
          }&workOrderEmailAddress=${
            this.searchValue?.workOrderEmailAddress || ""
          }&workOrderPhoneNumber=${
            this.searchValue?.workOrderPhoneNumber || ""
          }&companyLicense=${this.searchValue?.companyLicense || ""}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body?.companies) {
            this.isLoading = false;
            this.companies = res.body?.companies?.data || [];
            this.kpiData = res.body?.stats;
            this.totalCount = res.body?.companies?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  handlePaymentInfo(companyId) {
    const data = {
      companyId: companyId,
      services: this.services,
    };
    this.dialog
      .open(AddCompanyComponent, {
        data: data,
        width: "800px",
        height: "80vh",
        panelClass: "addCompany",
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.getAllCompanies();
        }
      });
  }

  toggleTab(isShowCompany: boolean) {
    this.isShowCompany = isShowCompany;
    if (this.isShowCompany) {
      this.getAllCompanies();
    }
  }

  onTabChange(event) {
    this.tabName = this.tabNames[event.tab?.textLabel];
    this.searchForm.setValue(this.searchForm.value as any);
    this.searchForm.updateValueAndValidity();
    this.getAllCompanies();
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getAllCompanies();
  }
  handleSearch(event: any) {
    this.searchValue = event;
    this.getAllCompanies();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
